import { Accordion, Toggle } from '@bswing/uhc-core';
import { useState } from 'react';
import PlanDetailActions from '../plan-detail-actions/plan-detail-actions';
import CoverageDentistsTable from './coverage-dentists-table';
import CoverageDoctorsTable from './coverage-doctors-table';
import CoverageDrugsTable from './coverage-drugs-table';
import CoverageRiders from './coverage-riders';

const PlanDetailCoverage = (props) => {
  const {
    data,
    isSaved,
    savedDoctors = [],
    savedDrugs = [],
    showCompare,
    showDentists,
    showDrugPricingUnavailable,
    onAddDoctorsClick = () => {},
    onAddDrugsClick = () => {},
    onPlanSaveToggle = () => {}
  } = props;

  const [sectionToggles, setSectionToggles] = useState(
    data ? data.coverageDetails.sections.map(() => 0) : []
  );

  const handleToggleChange = (event, index) => {
    let newArr = [...sectionToggles];
    newArr[index] = event;
    setSectionToggles(newArr);
  };

  return (
    <div className="container container-lg">
      <div className="row">
        <div className="column column-12">
          <div className="heading-2 mb-10 text-dark">Coverage Details</div>
          <div className="text-normal text-lg-large border-bottom pb-20">
            {data?.coverageDetails.description}
          </div>
          {data?.coverageDetails.sections.map((section, index) => (
            <div className="border-bottom" key={index}>
              <Accordion
                id={`section-${index}`}
                arrowColorOverride="#196ecf"
                isExpanded={index === 0}
                isMinimal={true}
                header={
                  <div>
                    <div className="heading-5 text-blue-primary">
                      {section.name}
                    </div>
                    {section.description && (
                      <div className="mt-5">{section.description}</div>
                    )}
                  </div>
                }
              >
                <div className="d-flex flex-column gap-20 pb-20">
                  {section.showDentists && (
                    <CoverageDentistsTable showDentists={showDentists} />
                  )}
                  {section.showDoctors && (
                    <CoverageDoctorsTable
                      savedDoctors={savedDoctors}
                      onAddDoctorsClick={onAddDoctorsClick}
                    />
                  )}
                  {section.showDrugs && (
                    <CoverageDrugsTable
                      savedDrugs={savedDrugs}
                      showDrugPricingUnavailable={showDrugPricingUnavailable}
                      onAddDrugsClick={onAddDrugsClick}
                    />
                  )}
                  {section.showNetworkToggle && (
                    <div className="d-block d-lg-none">
                      <Toggle
                        label="Network Toggle"
                        onChange={(event) => handleToggleChange(event, index)}
                        options={['In-network', 'Out-of-network']}
                      />
                    </div>
                  )}
                  {section.tables &&
                    section.tables.map((table, tableIndex) => (
                      <div key={tableIndex}>
                        {table.title && (
                          <div className="text-bold text-lg-large mb-10">
                            {table.title}
                          </div>
                        )}
                        <div className="border border-rounded-sm overflow-hidden">
                          <table style={{ tableLayout: 'fixed' }}>
                            {table.headers && (
                              <thead>
                                <tr className="bg-gray-2">
                                  {table.headers.map((header, headerIndex) => (
                                    <th
                                      className={`text-bold text-blue-primary p-20 ${
                                        headerIndex > 0
                                          ? 'd-none d-lg-table-cell'
                                          : ''
                                      }`}
                                      key={headerIndex}
                                      style={{
                                        width:
                                          headerIndex === 0 ? '35%' : 'auto'
                                      }}
                                    >
                                      {header}
                                    </th>
                                  ))}
                                </tr>
                              </thead>
                            )}
                            <tbody>
                              {table.rows.map((row, rowIndex) => (
                                <tr
                                  className={
                                    rowIndex % 2
                                      ? 'bg-gray-2 valign-top'
                                      : ' valign-top'
                                  }
                                  key={rowIndex}
                                >
                                  {row.map((rowData, rowDataIndex) => (
                                    <td
                                      className={`p-20 text-lg-large ${
                                        rowDataIndex > 0
                                          ? 'd-none d-lg-table-cell'
                                          : ''
                                      }`}
                                      colSpan={
                                        rowData.colSpan ? rowData.colSpan : 1
                                      }
                                      key={rowDataIndex}
                                      style={{
                                        width:
                                          rowDataIndex === 0 ? '35%' : 'auto'
                                      }}
                                    >
                                      <span
                                        className={
                                          rowDataIndex === 0 ? 'text-bold' : ''
                                        }
                                        dangerouslySetInnerHTML={{
                                          __html: rowData.value
                                        }}
                                      />
                                      <span className="d-block d-lg-none mt-10">
                                        {row[
                                          rowDataIndex +
                                            1 +
                                            (row[rowDataIndex + 1] &&
                                            row[rowDataIndex + 1].colSpan
                                              ? 0
                                              : sectionToggles[index])
                                        ] &&
                                          row[
                                            rowDataIndex +
                                              1 +
                                              (row[rowDataIndex + 1] &&
                                              row[rowDataIndex + 1].colSpan
                                                ? 0
                                                : sectionToggles[index])
                                          ].prefix &&
                                          `${
                                            row[
                                              rowDataIndex +
                                                1 +
                                                (row[rowDataIndex + 1] &&
                                                row[rowDataIndex + 1].colSpan
                                                  ? 0
                                                  : sectionToggles[index])
                                            ].prefix
                                          }: `}
                                        {row[
                                          rowDataIndex +
                                            1 +
                                            (row[rowDataIndex + 1] &&
                                            row[rowDataIndex + 1].colSpan
                                              ? 0
                                              : sectionToggles[index])
                                        ] && (
                                          <span
                                            dangerouslySetInnerHTML={{
                                              __html:
                                                row[
                                                  rowDataIndex +
                                                    1 +
                                                    (row[rowDataIndex + 1] &&
                                                    row[rowDataIndex + 1]
                                                      .colSpan
                                                      ? 0
                                                      : sectionToggles[index])
                                                ].value
                                            }}
                                          />
                                        )}
                                      </span>
                                    </td>
                                  ))}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    ))}
                  {section.showRiders && <CoverageRiders />}
                  {section.showCTA && (
                    <PlanDetailActions
                      isSaved={isSaved}
                      showCompare={showCompare}
                      onPlanSaveToggle={onPlanSaveToggle}
                    />
                  )}
                </div>
              </Accordion>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PlanDetailCoverage;
